// @ts-nocheck
import React, { useEffect, useState } from 'react';

import { sendAnalyticsEvent, sendRudderstackEvent } from 'dpl/util/analytics';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURES
} from 'dpl/constants/analytics';

import SelectPaymentTypeRadio from './SelectPaymentTypeRadio';
import SelectPaymentTypeConfirmation from './SelectPaymentTypeConfirmation';
import { PAYMENT_TIER_TYPE } from './constants';
import {
  getPaymentAndSupportListItems,
  getBasicProtectionAndSupportListItems
} from './util';

const { PROTECTED, BASIC } = PAYMENT_TIER_TYPE;

type PaymentTierType =
  (typeof PAYMENT_TIER_TYPE)[keyof typeof PAYMENT_TIER_TYPE];

interface SelectPaymentTypeProps {
  amount: number;
  selectedProtectionType: PaymentTierType;
  dogPayment: boolean;
  onHandleSelection: (type: PaymentTierType) => void;
  onCloseClick: () => void;
  onSave: () => void;
  fee?: string | null;
  onChangeModal?: (newModalName: string, allowGoBack?: boolean) => void;
}

export default function SelectPaymentType({
  amount,
  fee = null,
  onHandleSelection,
  selectedProtectionType,
  onCloseClick,
  onSave,
  onChangeModal = () => {},
  dogPayment
}: SelectPaymentTypeProps) {
  const [showConfirmation, setShowConfirmation] = useState(false);

  useEffect(() => {
    sendAnalyticsEvent(ANALYTICS_EVENTS.PAYMENT_MODAL_VIEWED_BY_BUYER, {
      view: ANALYTICS_VIEWS.PROTECTION_SUPPORT_CHANGE_SELECTION,
      view_feature: ANALYTICS_VIEW_FEATURES.PAYMENT_CHECKOUT_PAGE
    });
  }, []);

  function handleSave() {
    onCloseClick();
    onSave();
  }

  function trackEvent(buttonCta: string) {
    sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      button_cta: buttonCta,
      view: 'buyer_payment_summary'
    });
  }

  return (
    <div className="SelectPaymentType pv4 ph4 pv14-sm ph16-sm">
      <h4 className="f4 f6-md mb4 mb8-sm lh-normal tc">Select payment type</h4>
      <div className="mb4">
        <SelectPaymentTypeRadio
          title="Protection &amp; Support"
          name="protection-and-support"
          fee={fee}
          icon="fetch-payment-secure"
          listItems={getPaymentAndSupportListItems(amount, dogPayment)}
          onSelect={() => onHandleSelection(PROTECTED)}
          isSelected={selectedProtectionType === PROTECTED}
          onChangeModalClick={onChangeModal}
        />
      </div>
      <div className="mb8">
        <SelectPaymentTypeRadio
          title="Friends & Family (not protected)"
          name="no-protection-and-support"
          icon="fetch-headset"
          listItems={getBasicProtectionAndSupportListItems(amount, dogPayment)}
          onSelect={() =>
            selectedProtectionType === PROTECTED && setShowConfirmation(true)
          }
          isSelected={selectedProtectionType === BASIC}
        />
      </div>
      <SelectPaymentTypeConfirmation
        isVisible={showConfirmation}
        amount={amount}
        dogPayment={dogPayment}
        onKeepConfirm={() => {
          trackEvent('keep_protection_and_support');
          onHandleSelection(PROTECTED);
          setShowConfirmation(false);
        }}
        onCancelConfirm={() => {
          trackEvent('no_protection_and_support');
          onHandleSelection(BASIC);
          setShowConfirmation(false);
        }}
      />
      <button
        type="button"
        onClick={handleSave}
        className="bg-blue-500 fw-medium white pv4 br2 w-100 tc font-16"
      >
        Save selection
      </button>
    </div>
  );
}
